<template>
  <div class="basic_wrap">
    <div class="red_top_bg">
      <div class="back_left" @click="$router.back()">返回</div>
      <div class="big_tit">账户安全</div>
    </div>
    <div class="wrap">
      <div class="write_new_pwd">
        <div class="write_box">
          <input v-model="mobile" disabled />
        </div>
        <div class="write_box">
          <input v-model="realname" disabled />
        </div>
        <div class="write_box">
          <input value="修改登录密码" readonly @click="jump('setpwd')" />
        </div>
        <div class="write_box">
          <input value="修改支付密码" readonly @click="jump('setpaypwd')" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue'
  import { CountDown } from 'vant'
  import Fetch from '../../utils/fetch'

  Vue.use(CountDown)

  export default {
    name: 'Setpwd',
    data() {
      return {
        user_info: null,
        time: 0,
        mobile: '',
        realname: '',
        codeStatus: true,
        codeOK: false,
        code: '',
        is_send: false,
      }
    },
    created() {
      this.$parent.footer('user', false)
    },
  mounted() {
    document.getElementById('app').style.background =
      'linear-gradient(to bottom, #5674d3, #a8b6e5)'
    document.getElementById('app').style.marginBottom = '0px'
    
    Fetch('/user/info').then((r) => {
      this.mobile = '用户名：' + r.data.mobile
      // 根据 is_auth 字段判断实名状态
      this.realname = '实名认证：' + (r.data.is_auth === 1 ? '已实名' : '未实名')
      this.user_info = r.data
    })
  },
    methods: {
      jump(url) {
        window.location.href = '/#/' + url
      },
    },
  }
</script>

<style lang="less" scoped>
  .red_top_bg {
    height: 168px;
    // background-image: url(../images/user/moneybag/bg.png);
    // position: fixed;
    // background-position: center;
    // background-repeat: no-repeat;
    // background-size: 100% 100%;
    background: linear-gradient(to left, #5674d3, #a8b6e5);
    height: 50px;
  }
  // .back_left {
  //   background: url(../../views/images/item/back_b.png) no-repeat center center;
  // }
  .big_tit {
    color: #fff;
  }
  .no_touch {
    pointer-events: none;
  }

  .wrap {
    padding: 15px 20px 0 20px;
  }

  .title {
    width: 100%;
    height: 25px;
    line-height: 25px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    p {
      font-size: 18px;
      color: #000;
      font-weight: 400;
    }

    .cut {
      font-size: 12px;
      color: #3d96ff;
    }
  }

  .bd_tel {
    margin-top: 23px;
    color: #000;
    font-size: 14px;
    font-weight: 400;
  }

  .inp_box {
    display: flex;
    justify-content: space-between;
    height: 45px;
    margin-top: 9px;

    .inp {
      width: 195px;
      border: 1px solid rgba(0, 0, 0, 0.1);
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 0 10px;
      border-radius: 2px;
      background-color: #ffffff;

      input {
        width: 100%;
        height: 22px;
        line-height: 22px;
        font-size: 16px;
      }
    }

    .getcode {
      flex: 1;
      margin-left: 10px;
      font-size: 16px;
      text-align: center;
      line-height: 45px;
      color: #ffffff;
      height: 45px;
      background: linear-gradient(
        90deg,
        rgba(228, 57, 46, 1) 0%,
        rgba(255, 77, 22, 1) 100%
      );
      border-radius: 8px;
    }

    .reset_code {
      background: rgba(228, 228, 228, 1);
      color: rgba(0, 0, 0, 0.3);
    }
  }

  .write_box {
    width: 100%;
    height: 45px;
    margin-top: 10px;
    background: rgba(255, 255, 255, 1);
    border-radius: 2px;
    border: 1px solid rgba(0, 0, 0, 0.1);
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 10px;
    border-radius: 10px;
    background-color: #ffffff;

    input {
      width: 100%;
      height: 22px;
      line-height: 22px;
      font-size: 16px;
      color: rgb(153, 153, 153);
    }
  }

  .eye_bi {
    width: 21px;
    height: 25px;
    background: url(../images/user/eye2.png) no-repeat center center;
    background-size: 100% auto;

    &.eye {
      background: url(../images/user/eye1.png) no-repeat center center;
      background-size: 100% auto;
    }
  }

  .basic_btn {
    margin: 43px auto 0 auto;
    height: 45px;
    line-height: 45px;
    font-size: 16px;
    width: 90%;
    background: linear-gradient(to left, #756ff3, #399ffe);
    border-radius: 10px;
    color: #ffffff !important;
    text-align: center;
    margin-top: 20px !important;
  }
</style>
